module.exports = __webpack_public_path__ + "static/MC_clasica_app_fisica-9ad2279ccf057249856c42b2eb4cd65a.jpg";